import React, { useEffect, useState, useContext } from "react";
import styles from "./style.module.scss";

import { useNavigate } from "react-router-dom";

import logo from "../../assets/image/Frame.png";

import { MainContext } from "../../context/MainContext";

function Comment() {
  const navigate = useNavigate();

  const { action, markers } = useContext(MainContext);
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    const res = action.filter((item) => item.type === "comment");
    if (res.length > 0 && Array.isArray(res[0].actions)) {
      const reversed = [...res[0].actions].reverse();
      setNotes(reversed);
    }
  }, [action]);

  const picture = (id) => {
    const result = markers.find((marker) => marker.id === id);
    if (!result) {
      return;
    }
    return result.photo;
  };

  return (
    <React.Fragment>
      <div className={styles.comment__banner}>
        <div className={styles.comment__banner__content}>
          <img className={styles.comment__banner__logo} src={logo} alt="logo" />
          <div>
            <h3 className={styles.comment__banner__content_title}>FIRE SAFETY</h3>
            <p className={styles.comment__banner__content_text}>Center</p>
          </div>
        </div>
        <div className={styles.comment__banner__profile}>
          <button className={styles.comment__banner__profile__btn} onClick={() => navigate("/")}>
            Return
          </button>
        </div>
      </div>
      <div className={styles.comment}>
        <div className={styles.comment__search}>
          <div className={styles.comment__search__title}>Заметки</div>
        </div>
        <div className={styles.comment__container}>
          {notes.length !== 0 ? (
            <React.Fragment>
              {notes.map((elem, index) => (
                <div key={index} className={styles.comment__container__notes}>
                  <div className={styles.comment__container__notes__main}>
                    <span className={styles.comment__container__notes__main_text}>{elem.name}</span>
                    <span className={styles.comment__container__notes__main_text}>{elem.time}</span>
                  </div>
                  <div className={styles.comment__container__notes__footer}>
                    <img
                      src={picture(elem.id)}
                      className={styles.comment__container__notes__footer__img}
                      alt="logo"
                    />
                    <div>
                      <p className={styles.comment__container__notes__footer__text}>
                        {elem.nameObj}
                      </p>
                      <p className={styles.comment__container__notes__footer__text}>
                        {elem.address}
                      </p>
                    </div>
                  </div>
                  <span className={styles.comment__container__notes__footer__title}>
                    {elem.comment}
                  </span>
                </div>
              ))}
            </React.Fragment>
          ) : (
            <div className={styles.comment__container__error}>
              <span className={styles.comment__container__error__title}>Уведомление</span>
              <span className={styles.comment__container__error__text}>Заметки не найдены</span>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Comment;
